import { Column, type ColumnProps } from 'primereact/column';
import { DataTable, type DataTableValueArray } from 'primereact/datatable';
import styles from './simple-table.module.css';

interface Product {
	data: DataTableValueArray;
	columns: Array<ColumnProps>;
}

const SimpleTable = ({ data, columns }: Product) => {
	return (
		<DataTable
			value={data}
			pt={{
				wrapper: {
					className: styles.simpleTable,
				},
				thead: {
					className: styles.tableColumnHeader,
				},
				tbody: {
					className: styles.tableBody,
				},
			}}
		>
			{columns.map((item: ColumnProps) => (
				<Column
					key={item.field}
					field={item.field}
					header={item.header}
				/>
			))}
		</DataTable>
	);
};

export default SimpleTable;
